// Recovered compiled webpack factory 33078. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    let t = {};
    for (let [r, n] of e.entries()) {
      let e = t[r];
      void 0 === e ? (t[r] = n) : Array.isArray(e) ? e.push(n) : (t[r] = [e, n]);
    }
    return t;
  }
  function n(e) {
    return "string" == typeof e
      ? e
      : ("number" != typeof e || isNaN(e)) && "boolean" != typeof e
        ? ""
        : String(e);
  }
  function a(e) {
    let t = new URLSearchParams();
    for (let [r, a] of Object.entries(e))
      if (Array.isArray(a)) for (let e of a) t.append(r, n(e));
      else t.set(r, n(a));
    return t;
  }
  function o(e) {
    for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
      r[n - 1] = arguments[n];
    for (let t of r) {
      for (let r of t.keys()) e.delete(r);
      for (let [r, n] of t.entries()) e.append(r, n);
    }
    return e;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      assign: function () {
        return o;
      },
      searchParamsToUrlQuery: function () {
        return r;
      },
      urlQueryToSearchParams: function () {
        return a;
      },
    }));
}
